// utils/generateInfillLines.js
import ClipperLib from 'clipper-lib';



export function generateInfillLines(polygon, spacing = 5) {
    const scale = 1000;
    const directions = ['horizontal', 'vertical']; // 可以加上 'diagonal45', 'diagonal-45'
  
    const scaledPoly = polygon.map(([x, z]) => ({
      X: Math.round(x * scale),
      Y: Math.round(z * scale),
    }));
  
    const bounds = {
      minX: Math.min(...scaledPoly.map(p => p.X)),
      maxX: Math.max(...scaledPoly.map(p => p.X)),
      minY: Math.min(...scaledPoly.map(p => p.Y)),
      maxY: Math.max(...scaledPoly.map(p => p.Y)),
    };
  
    const allLines = [];
  
    for (const direction of directions) {
        const margin = 0.1 * scale; // 0.1mm 偏移，避免贴着边界线

        if (direction === 'horizontal') {
          for (let y = bounds.minY + margin; y <= bounds.maxY - margin; y += Math.round(spacing * scale)) {
            allLines.push([
              { X: bounds.minX, Y: y },
              { X: bounds.maxX, Y: y },
            ]);
          }
        } else if (direction === 'vertical') {
          for (let x = bounds.minX + margin; x <= bounds.maxX - margin; x += Math.round(spacing * scale)) {
            allLines.push([
              { X: x, Y: bounds.minY },
              { X: x, Y: bounds.maxY },
            ]);
          }
        }
    }
  
    const clipper = new ClipperLib.Clipper();
    clipper.AddPaths(allLines, ClipperLib.PolyType.ptSubject, false);
    clipper.AddPaths([scaledPoly], ClipperLib.PolyType.ptClip, true);
  
    const solutionTree = new ClipperLib.PolyTree();
    const succeeded = clipper.Execute(
      ClipperLib.ClipType.ctIntersection,
      solutionTree,
      ClipperLib.PolyFillType.pftNonZero,
      ClipperLib.PolyFillType.pftNonZero
    );
  
    if (!succeeded) return [];
  
    const solution = ClipperLib.Clipper.OpenPathsFromPolyTree(solutionTree);
  
    const infillSegments = [];
    for (const path of solution) {
      if (path.length < 2) continue;
      for (let i = 0; i < path.length - 1; i++) {
        const p1 = path[i], p2 = path[i + 1];
        infillSegments.push([
          { x: p1.X / scale, z: p1.Y / scale },
          { x: p2.X / scale, z: p2.Y / scale }
        ]);
      }
    }
  
    return infillSegments;
  }
  

